<template>
    <div>
        <div :class="isModal ? `modal-overlay active` : ''"></div>
        <div ref="modalBody" :class="isModal ? `modal` : ''">
            <div class="modal__header">
                <h2 id="reviewModalTitle" class="headline-s">Write a Review</h2>
                <CloseIcon v-if="isModal" @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body flex-column" id="reviewModalBody">
                    <div>
                        <p class="title-l text-rothcoText">Rating</p>
                        <div style="display: flex; flex-direction: row; align-items: center;">
                            <Rating ref="ratings" v-model="reviews.rating" class="flex-row-review-stars">
                                <template #onicon>
                                    <StarFilled height="25" width="25" />
                                </template>
                                <template #officon>
                                    <StarEmpty height="25" width="25" />
                                </template>
                            </Rating>
                            <p class="paragraph-feature text-rothcoText align-center">&nbsp;&nbsp;{{ reviews.rating ?? 0 }}&nbsp;stars</p>
                        </div>
                    </div>
                    <div class="input-folder">
                        <div class="input-folder--input">
                            <input type="text" :id="`emailInput${isModal ? 'Modal' : ''}`" v-model="reviews.user_email" placeholder=" " required>
                            <label :for="`emailInput${isModal ? 'Modal' : ''}`">
                                <p class="paragraph-default">Email Address *</p>
                            </label>
                        </div>
                    </div>
                    <div class="input-folder">
                        <div class="input-folder--input">
                            <input type="text" :id="`nameInput${isModal ? `Modal` : ''}`" v-model="reviews.user_name" placeholder=" " required>
                            <label :for="`nameInput${isModal ? `Modal` : ''}`">
                                <p class="paragraph-default">Full Name *</p>
                            </label>
                        </div>
                    </div>
                    <div class="textarea-folder">
                        <textarea :id="`textAreaInput${isModal ? `Modal` : ''}`" v-model="reviews.review" required class="input-folder--input" style="border-style: solid; border-width: 1px;" placeholder=" "></textarea>
                        <label :for="`textAreaInput${isModal ? `Modal` : ''}`"><p class="paragraph-default">Review *</p></label>
                    </div>
                    <Recaptcha v-if="!user_id" ref="recaptcha" v-model="captchaResponse" theme="light" />
                    <div class="review-modal-footer">
                        <RothcoCta id="submitButton" :class="formValid ? `primary` : `disabled`" @click="submit">Submit Review</RothcoCta>
                        <a v-if="isModal" @click="cancel">Cancel</a>
                    </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { reactive, computed, ref } from "vue";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    import { inject } from "vue";
    import { useFetch } from "@/helpers/composables/useFetch";
    import Recaptcha from "@/components/Recaptcha.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import Rating from 'primevue/rating';
    import { onClickOutside } from "@vueuse/core";
    import CloseIcon from "@icons/closeIcon.svg";
    import StarFilled from "@icons/star-filled.svg";
    import StarEmpty from "@icons/star-empty.svg";
    const dialogRef = inject('dialogRef');
    
    const sitekey= computed(()=>{
        return import.meta.env.VITE_RECAPTCHA_SITE_KEY;
    })

    const closeDialog = () => {
        dialogRef?.value?.close();
    }

    const itemId = dialogRef?.value?.data?.itemId ?? null;

    const isModal = dialogRef?.value?.data?.isModal ?? false;
    let settings = useSettingsStore()
    const { user_id } = storeToRefs(settings);
    const { setNotificationMessage } = settings;
    const reviews = reactive({
        user_email: "",
        user_name: "",
        review: "",
        rating: 0,
        item_id: itemId,
        user_id: user_id.value
    });
    const formValid = computed(() => {
        return (
            reviews.item_id != null &&
            reviews.user_email != "" &&
            reviews.user_email != null &&
            reviews.review != "" &&
            reviews.review != null &&
            reviews.user_name != "" &&
            reviews.user_name != null &&
            (user_id.value ?  true : captchaResponse.value != null && captchaResponse.value != '')
        );
    });
    const submitLoading = ref(false);
    const submit = function () {
        if(formValid.value){
            const { data: postResponse } = useFetch(route("products.add_review"), {immediate: true, 
                beforeFetch({cancel}){
                    if(submitLoading.value){
                        cancel()
                    }
                    submitLoading.value = true;
                },
                afterFetch(ctx){
                    submitLoading.value = false;
                    closeDialog();
                    setNotificationMessage({
                        type: "success",
                        message: "Review submitted successfully"
                    });
                },
                onFetchError(ctx){
                    submitLoading.value = false;
                    setNotificationMessage({
                        type: "error",
                        message: "An error occurred while submitting the review. Please try again."
                    });
                }
            }).post({
                reviews
            }).json();
        }
    };
    const cancel = function () {
        reviews.user_email = "";
        reviews.user_name = "";
        reviews.review = "";
        reviews.rating = 0;
        closeDialog();
    };

    let captchaResponse = ref();

    let recaptcha = ref();
    let ratings = ref();
    let modalBody = ref();

    onClickOutside(modalBody, () => {
        closeDialog();
    });
</script>
<style scoped>
    .review-modal-footer {
        display: flex; 
        flex-direction: row; 
        justify-content: right; 
        align-items: center; 
        gap: 3rem;
    }
    .flex-row-review-stars {
        display: flex;
        flex-direction: row;
    }
</style>